export default __webpack_public_path__ + "static/earning-insight-adeb7bb513b35f4c8f95ce4154ecc899.webm";